/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierProBlockReplacement
 */
export interface CarrierProBlockReplacement {
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockReplacement
   */
  carrierProBlockId: string;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockReplacement
   */
  startNumber: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockReplacement
   */
  endNumber: number;
}

/**
 * Check if a given object implements the CarrierProBlockReplacement interface.
 */
export function instanceOfCarrierProBlockReplacement(
  value: object,
): value is CarrierProBlockReplacement {
  if (
    !("carrierProBlockId" in value) ||
    value["carrierProBlockId"] === undefined
  )
    return false;
  if (!("startNumber" in value) || value["startNumber"] === undefined)
    return false;
  if (!("endNumber" in value) || value["endNumber"] === undefined) return false;
  return true;
}

export function CarrierProBlockReplacementFromJSON(
  json: any,
): CarrierProBlockReplacement {
  return CarrierProBlockReplacementFromJSONTyped(json, false);
}

export function CarrierProBlockReplacementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProBlockReplacement {
  if (json == null) {
    return json;
  }
  return {
    carrierProBlockId: json["carrierProBlockId"],
    startNumber: json["startNumber"],
    endNumber: json["endNumber"],
  };
}

export function CarrierProBlockReplacementToJSON(
  json: any,
): CarrierProBlockReplacement {
  return CarrierProBlockReplacementToJSONTyped(json, false);
}

export function CarrierProBlockReplacementToJSONTyped(
  value?: CarrierProBlockReplacement | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierProBlockId: value["carrierProBlockId"],
    startNumber: value["startNumber"],
    endNumber: value["endNumber"],
  };
}
